import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import axios from 'axios';
import { useSelector } from 'react-redux';
import envConfig from '../../../bin/env.config';
import { Typography, Box, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import SearchBox from '../../Common/SearchBox';

export default function CompanyProductMoveDialog({ open, onClose, item, projectId, doMoveItem }) {
  const token = useSelector((state) => state.session.token);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    const getData = async () => {
      setIsLoading(true)
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/products?project_id=${projectId}&limit=5&skip=0`;
      const result = await axios.post(url,
        {q:searchText,notMappedYet:false}
        , {
        headers: {
          Authorization: token,
        },
      });
      setDataSource(result.data.data);
      setIsLoading(false)
    };
    searchText.length>0&&open&&getData();
  }, [searchText,open]);
  const doSearch = (searchValue) => {
    setSearchText(searchValue);
  };
  const doMoveItemLocal = async (id) => {
    const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/move-bproduct`;
    const result = await axios.post(url,
      {id:item.id,//old id of company_report_tool_product_detail
       product_matching_group_id:item.productMatchingGroup.id,
       company_report_tool_product_id:id
      }
      , {
      headers: {
        Authorization: token,
      },
    });
    onClose()  
    doMoveItem&&doMoveItem()   
  }
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Move/change group of "{item.productMatchingGroup.id}"</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={3} align="right">
              <SearchBox value={searchText} doSearch={doSearch} searchOnChange={true} placeholder="Search"/>
            </TableCell> 
          </TableRow>
        <TableRow>
          <TableCell align="right" width="100px">#</TableCell>
          <TableCell align="center" width="100px">ID</TableCell> 
          <TableCell align="left" >Name</TableCell> 
          </TableRow>
        </TableHead>
        <TableBody>
                 {isLoading&&
                 <TableRow>
                  <TableCell colSpan={4}> Loading...</TableCell>
                  </TableRow>}
                  {dataSource.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell align="right">
                        {row.id!=item.company_report_tool_product_id &&
                        <Button variant="contained" size="small" color="primary" onClick={() => doMoveItemLocal(row.id)}>
                          Move to
                        </Button>
                        }
                      </TableCell>
                      <TableCell align="center">{row.id}</TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                    </TableRow>
                  ))}
        </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
} 